<ng-container *ngIf="userDetails$ | async as userDetails">
  <!-- <bh-alert *ngIf="userSapBlocked" class="blocked-info" style='position: static' alerts='[{"status":"info","message":"This customer is not eligible to create Orders and Quotes. Please contact ","isOpen":true}]' type='default'  timeout='false' dismiss-after='8000' >
    <a href="/contactus" class="contact-us">Customer care</a>
  </bh-alert> -->

  <div class="logged-in-landing">
    <div class="row">
      <div class="col-md-6">
        <p class="welcome-user-text">
          {{ 'landing.welcome' | cxTranslate }} {{ userDetails.name }}
        </p>
        <span class="login-date">
          {{ getTodaysDate() }}
        </span>
      </div>
      <div class="col-md-6">
        <div class="factoryshop-info">
          <p class="header-text">{{ 'landing.factoryshop' | cxTranslate }}</p>
          <div>
            <ng-container *ngIf="user$ | async as user">
              <p class="content-text">
                <span
                  >{{ user?.recentSalesArea?.salesOrganization }} ({{
                    user?.recentSalesArea?.uid
                  }})</span
                >
                <span class="content-text">{{
                  user?.recentSalesArea?.salesAreaAddress?.formattedAddress
                }}</span>
              </p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="row widgets">
      <div class="col-md-6">
        <vs-create-order-widget></vs-create-order-widget>
      </div>
      <div class="col-md-6 search-serial-container">
        <div class="row">
          <div class="col-md-8">
            <div class="">
              <label class="add-search">
                {{ 'landing.serialNoHeader' | cxTranslate }}
              </label>

              <div class="search-input">
                <input
                  type="text"
                  class="form-control serialno-input"
                  (keyup)="keyUp(search, $event)"
                  placeholder="{{ 'landing.minChar' | cxTranslate }}"
                  [(ngModel)]="serialNo"
                  #search
                  name="search"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="search-button">
              <button
                class="vs-primary-btn sample-btn"
                (click)="modelChange(search)"
                (keyup)="keyUp(search, $event)"
              >
                <span>{{ 'landing.searchButton' | cxTranslate }}</span>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 recent-search-txt">
            {{ 'landing.recentSearchTxt' | cxTranslate }}
          </div>
          <div class="col-md-3 recent-search-list" *ngFor="let item of recentSearchUserData" (click)="setRecentSearchInput(item)">
            {{item}}
          </div>
        </div>
      </div>
    </div>
    <div class="row widgets">
      <div class="col-md-12">
        <vs-quick-links></vs-quick-links>
      </div>
    </div>
    <div class="row widgets">
      <div class="col-md-6">
        <vs-featured-products></vs-featured-products>
      </div>
      <div class="col-md-6">
        <vs-additional-resources></vs-additional-resources>
      </div>
    </div>
  </div>
</ng-container>
